import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { IconModule } from '@spartacus/storefront'
import { SharedModule } from '../../../shared/shared.module'
import { NewCreditClaimModalComponent } from './new-credit-claim-modal.component'

@NgModule({
  declarations: [NewCreditClaimModalComponent],
  imports: [CommonModule, SharedModule, IconModule, ReactiveFormsModule]
})
export class NewCreditClaimModalModule {}
